import { createContext } from 'react'

const ExternalServicesContext = createContext()

export default ExternalServicesContext
